import React from 'react'
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as ArrowRightIcon } from "../Assets/svg/ArrowRightIcon.svg";
import { useNavigate } from 'react-router-dom';
function PageLayout(props) {
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }
    return (
        <Box sx={{ paddingTop: '60px' }}>
            <Box className='header-page' sx={{ px: 3, py: 2 }}>
                <Box sx={{display:'flex',gap:"10px"}}>
                    <IconButton variant="text" sx={{ p: 1 }} onClick={goBack}>
                        <ArrowRightIcon />
                    </IconButton>
                    <Box component="div" sx={{ display: 'inline', mr: 2, fontSize: '17px' }}>
                        {props.title}
                    </Box>
                    <Box> {props.rightHeaderItem ? props.rightHeaderItem : ""}</Box> 
                </Box>
               <Box> {props.leftHeaderItem ? props.leftHeaderItem : ""}</Box> 
            </Box>
            <Box>
                {props.children}
            </Box>
        </Box>
    );
}

export default PageLayout;